import { createOafRouter, defaultSettings } from 'oaf-routing';

const { RouteService: { isModal } } = window;

export const longestCommonPrefix = (strs) => {
  let prefix = '';
  if (strs === null || strs.length === 0) return prefix;

  for (let i = 0; i < strs[0].length; i += 1) {
    const char = strs[0][i]; // loop through all characters of the very first string.

    for (let j = 1; j < strs.length; j += 1) {
      // loop through all other strings in the array
      if (strs[j][i] !== char) return prefix;
    }
    prefix += char;
  }

  return prefix;
};

// Exceptions to scroll up when navigating through the subroutes
const noScrollToTop = [
  [/\/sports\/\d+\/meetings\/\d+\/events\/\d+\/market_group\/(\d*)/, /\d+/], // event-level coupon groups
  [/\/sports\/\d+\?tab=(\d*)/, /\d+/], // sport home tabs
  [/\/(live-)?casino\/category\//, /\w+/], // casino categories
];

const isCasinoSearch = ({ prevUrl, nextUrl, prefix }) => {
  const regex = /\/search(?:\?([\s\S]*))?$/;
  return regex.test(nextUrl) || (regex.test(prevUrl) && prefix.length > 1);
};

export const shouldHandleAction = (prevLocation, nextLocation/* , action */) => {
  const prevUrl = `${prevLocation.pathname}${prevLocation.search}`;
  const nextUrl = `${nextLocation.pathname}${nextLocation.search}`;

  const prefix = longestCommonPrefix([prevUrl, nextUrl]);
  const newSuffix = nextUrl.slice(prefix.length);

  // modals never need scrolling up
  if (isModal(nextLocation.pathname) || isModal(prevLocation.pathname)) return false;
  // casino search is hard to detect by paths because heartbingo
  // can have any category from the CMS in the url
  if (isCasinoSearch({ prevUrl, nextUrl, prefix })) return false;
  // various path transition exceptions
  if (noScrollToTop.some(([common, diff]) => (common.test(prefix) && diff.test(newSuffix)))) {
    return false;
  }

  return true;
};

export const wrapHistory = (history, settingsOverrides = {
  shouldHandleAction,
  announcePageNavigation: false,
  primaryFocusTarget: '#root > .center-content',
}) => {
  const settings = {
    ...defaultSettings,
    ...settingsOverrides,
  };

  const oafRouter = createOafRouter(settings, (location) => location.hash);

  const initialLocation = history.location;

  // HACK: We use setTimeout to give React a chance to render before we repair focus.
  setTimeout(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    oafRouter.handleFirstPageLoad(initialLocation);
  }, settings.renderTimeout);

  let previousLocation = initialLocation;

  const unlisten = history.listen((newLocation, action) => {
    // We're the first subscribed listener, so the DOM won't have been updated yet.
    oafRouter.handleLocationWillChange(
      previousLocation.key,
      newLocation.key,
      action,
    );

    // HACK: We use setTimeout to give React a chance to render before we repair focus.
    const stablePreviousLocation = previousLocation;
    setTimeout(() => {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      oafRouter.handleLocationChanged(
        stablePreviousLocation,
        newLocation,
        newLocation.key,
        action,
      );
    }, settings.renderTimeout);

    previousLocation = newLocation;
  });

  return () => {
    oafRouter.resetAutoScrollRestoration();
    unlisten();
  };
};
